import { notify } from 'utils/reduxUtils';

export const types = {
  CLOSE: 'settings/company/supplierFacilitiesDrawer/CLOSE',
  OPEN_ERROR: 'settings/company/supplierFacilitiesDrawer/OPEN_ERROR',
  OPEN_REQUEST: 'settings/company/supplierFacilitiesDrawer/OPEN_REQUEST',
  OPEN_SUCCESS: 'settings/company/supplierFacilitiesDrawer/OPEN_SUCCESS',
  SAVE_ERROR: 'settings/company/supplierFacilitiesDrawer/SAVE_ERROR',
  SAVE_REQUEST: 'settings/company/supplierFacilitiesDrawer/SAVE_REQUEST',
  SAVE_SUCCESS: 'settings/company/supplierFacilitiesDrawer/SAVE_SUCCESS',
  SET_SUPPLIER_FACILITY:
    'settings/company/supplierFacilitiesDrawer/SET_SUPPLIER_FACILITY',
};

export const supplierFacilityDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  setSupplierFacility: ({ supplierFacility }) => ({
    type: types.SET_SUPPLIER_FACILITY,
    payload: { supplierFacility },
  }),
};

export const open = {
  error: notify(
    (error) => ({
      type: types.OPEN_ERROR,
      payload: error,
    }),
    'Failed to edit facility information',
  ),
  request: ({ supplierFacilityId, callBack, mode }) => ({
    type: types.OPEN_REQUEST,
    payload: {
      supplierFacilityId,
      callBack,
      mode,
    },
  }),
  success: () => ({
    type: types.OPEN_SUCCESS,
  }),
};

export const save = {
  error: notify(
    (error) => ({
      type: types.SAVE_ERROR,
      payload: error,
    }),
    'Failed to save facility information',
  ),
  request: ({
    address1,
    address2,
    city,
    country,
    deleteLogo,
    isDefault,
    logoFile,
    name,
    phone,
    phoneExt,
    postalCode,
    state,
    url,
  }) => ({
    type: types.SAVE_REQUEST,
    payload: {
      address1,
      address2,
      city,
      country,
      deleteLogo,
      isDefault,
      logoFile,
      name,
      phone,
      phoneExt,
      postalCode,
      state,
      url,
    },
  }),
  success: notify(
    ({ supplierFacilityId }) => ({
      type: types.SAVE_SUCCESS,
      payload: { supplierFacilityId },
    }),
    'Successfully saved facility information',
  ),
};
